import React, { useEffect } from "react";
import { useState } from "react";
import { Redirect } from "react-router";

// Components
import BoxOver from '../shared/BoxOver';
import Form from '../shared/Form';
import Header from "../shared/Header";
import LogosContainer from "../shared/LogosContainer";
// Styles
import * as SharedStyled from '../shared/styles';
import * as Styled from './styles';
// utils
import { fetchTypes } from '../../utils/fetch'
// libs
import * as moment from 'moment';
// assets
import { helpMessages as messages }  from '../../assets/messages'
import { aboutMessages as aboutText }  from '../../assets/messages'
import { logosCreatedBy, logosSources }  from '../../assets/images'


function Home({ logo }) {
    const [ searchOptions, setSearchOptions ] = useState({
        user_string: '',
        api_url: '',
    })
    const [ goToResults, setGoToResults ] = useState(false)
    const [ showHelp, setShowHelp ] = useState(false)
    const [ typeOptions, setTypeOptions ] = useState([])

    useEffect(() => {
        fetchTypes()
            .then(types => {
                var options = types.map(t => {
                    return {
                        value: t.value,
                        label: t.value,
                        source: t.source
                    }
                })
                setTypeOptions(options)
            })        
    }, []) 

    function handleSubmit(types, sources, userString, dateInterval ) {
        // Adding queries to params object
        var params = {}
        
        if (types.length > 0) {
            const dashTypes = types.map(x => {
                return x.replace(' ', '-')
            })
            params = {...params, types: dashTypes.join('+')}
        }
        if (sources.length > 0) {
            for ( const source of sources ) {
                params[source]=true
            }
        }
        
        if (dateInterval.min !== '' && dateInterval.min !== null){
            params = {...params, dateMin: moment(dateInterval.min).format("DDMMyyyy")}
        }
        if (dateInterval.max !== '' && dateInterval.max !== null){
            params = {...params, dateMax: moment(dateInterval.max).format("DDMMyyyy")}
        }

        setSearchOptions({
            user_string: userString,
            params: params
        })

       setGoToResults(true)
    }

    return (
        <div>
            <Header
                logo={ logo }
            />

            <Styled.HomeContent>
                { showHelp && <BoxOver setState={ setShowHelp } messages={ messages }/> }                

                <Styled.BoxContainer size="62">
                    <SharedStyled.FloatingButton 
                        buttonType="info"
                        onClick={ () => setShowHelp(!showHelp) } 
                    >
                        ? 
                    </SharedStyled.FloatingButton>

                    <Form 
                        typeOptions={typeOptions}
                        handleSubmit={handleSubmit}
                    />
                </Styled.BoxContainer>

                <Styled.InfoBoxesContainer>
                    <Styled.BoxContainer column="true" size="32">
                        <h3>A project by:</h3>
                        <hr className="hr-min"></hr>
                        <LogosContainer logos={ logosCreatedBy }  vSize="3.5rem" />
                        <br/>
                        <h3>Sources:</h3>
                        <hr className="hr-min"></hr>
                        <LogosContainer logos={ logosSources } vSize="2.5rem" />
                    </Styled.BoxContainer>

                    <Styled.BoxContainer column="true" size="32">
                        <h3>{ aboutText.title }</h3>
                        <hr></hr>
                        { aboutText.content.map((p, i) => {
                            return <p key={i}>
                                { p }
                            </p>
                        }) }
                    </Styled.BoxContainer>
                </Styled.InfoBoxesContainer>


                {goToResults &&
                    <Redirect to={{
                        pathname: '/results',
                        state: searchOptions
                    }}/>
                }
            </Styled.HomeContent>
        </div>
    );
}

export default Home;
